import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import '@fortawesome/fontawesome-free/css/all.min.css';
import '@fontsource/open-sans/latin-300.css';
import '@fontsource/open-sans/latin-400.css';
import '@fontsource/open-sans/latin-600.css';
import '@fontsource/open-sans/latin-700.css';
import '@fontsource/open-sans/latin-ext-300.css';
import '@fontsource/open-sans/latin-ext-400.css';
import '@fontsource/open-sans/latin-ext-600.css';
import '@fontsource/open-sans/latin-ext-700.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
/* Legacy panel (skopiowane z m3u-studio/css/) — pełne reguły jak dashboard.html */
import './styles/dashboard-shell.css';
/* Dopasowanie pod React: #react-dashboard-root, wąski mobile drawer itd. */
import './styles/dashboard-layout.css';
import './index.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { PlaylistProvider } from './context/PlaylistContext';
import { ToastProvider } from './context/ToastContext';
import { UndoRedoProvider } from './context/UndoRedoContext';
import { EditorSessionProvider } from './context/EditorSessionContext';
import { DashboardModalsProvider } from './context/DashboardModalsContext';
import DashboardModalsHost from './components/dashboard-modals/DashboardModalsHost';

const routerBasename = import.meta.env.BASE_URL.replace(/\/$/, '') || undefined;

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter basename={routerBasename}>
      <AuthProvider>
        <PlaylistProvider>
          <ToastProvider>
            <UndoRedoProvider>
              <EditorSessionProvider>
                <DashboardModalsProvider>
                  <App />
                  <DashboardModalsHost />
                </DashboardModalsProvider>
              </EditorSessionProvider>
            </UndoRedoProvider>
          </ToastProvider>
        </PlaylistProvider>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
